import "./button.scss";

import classnames from "classnames";
import React from "react";

import { Text } from "../text/text";
import { Color } from "../text/types";

interface Props {
  title?: string;
  type?:
    | "primary"
    | "secondary"
    | "ghost-light"
    | "ghost-dark"
    | "ghost-dark-inverted";
  block?: Array<"mobile" | "tablet" | "desktop"> | boolean;
  align?: "left" | "center" | "right";
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  minHeight?: boolean;
  id?: string;
  ariaLabel?: string;
}

export function Button({
  type = "primary",
  align = "center",
  title,
  block,
  disabled,
  onClick,
  minHeight,
  id,
  ariaLabel,
}: Props): React.ReactElement {
  const textColors: Record<Required<Props>["type"] | "disabled", Color> = {
    primary: "accent-on-default",
    secondary: "secondary-on-default",
    "ghost-light": "secondary-default",
    "ghost-dark": "primary-on-default",
    "ghost-dark-inverted": "neutral-on-surface-lightest-inverse",
    disabled: "disabled-on-default",
  };
  const textHoverColors: Record<Required<Props>["type"], Color> = {
    primary: "accent-on-default",
    secondary: "secondary-on-default",
    "ghost-light": "secondary-hover",
    "ghost-dark": "primary-on-default",
    "ghost-dark-inverted": "neutral-on-surface-lightest-inverse",
  };

  return (
    <div
      className={classnames("button__wrapper", {
        "button__wrapper--block-mobile":
          typeof block === "boolean" || block?.includes("mobile"),
        "button__wrapper--block-tablet":
          typeof block === "boolean" || block?.includes("tablet"),
        "button__wrapper--block-desktop":
          typeof block === "boolean" || block?.includes("desktop"),
        "button__wrapper--min-height": minHeight,
      })}
    >
      <Text
        type="button"
        color={disabled ? textColors.disabled : textColors[type]}
        hoverColor={disabled ? undefined : textHoverColors[type]}
        fullWidth={!!block}
      >
        <button
          className={classnames(
            "button",
            type && `button--${type}`,
            `button--align-${align}`,
            {
              "button--block-mobile":
                typeof block === "boolean" || block?.includes("mobile"),
              "button--block-tablet":
                typeof block === "boolean" || block?.includes("tablet"),
              "button--block-desktop":
                typeof block === "boolean" || block?.includes("desktop"),
            },
          )}
          onClick={onClick}
          disabled={disabled}
          id={id}
          aria-label={ariaLabel}
        >
          {title && (
            <span
              className={classnames(
                "button__title",
                `button__title--align-${align}`,
              )}
            >
              {title}
            </span>
          )}
        </button>
      </Text>
    </div>
  );
}
